module.exports = __webpack_public_path__ + "img/birthYearUnderscore.3bf935b2.png";